import { defineMessages } from 'react-intl';

export default defineMessages({
    quotePremium: {
        id: 'quoteandbind.common.directives.common.Quoted Premium',
        defaultMessage: 'Quoted Premium'
    },
    paymentFrequencyLabel: {
        id: 'quoteandbind.ba.views.ba-policy-info.Payment Frequency',
        defaultMessage: 'Payment Frequency'
    },
    quoteAmountMonthly: {
        id: 'quoteandbind.common.directives.common.Monthly_Prefix',
        defaultMessage: '/ mo.'
    },
    quoteAmountMonthly1: {
        id: 'quoteandbind.common.directives.common.Monthly_Ext',
        defaultMessage: '(Based on 12 equal Monthly Payments)'
    },
    quoteFeesAndTaxes: {
        id: 'quoteandbind.common.directives.common.includes tax if applicable, financial fees extra',
        defaultMessage: 'includes tax if applicable, financial fees extra'
    },
    quoteMultiLine: {
        id: 'quoteandbind.common.directives.common.Multipolicy Discount',
        defaultMessage: 'Multipolicy Discount'
    },
    nonBlockingMessageTitle: {
        id: 'quoteandbind.common.directives.common.Non Blocking UW Messages',
        defaultMessage: 'Non Blocking UW Messages'
    }
});
